import { useState } from 'react'
import { twMerge } from 'tailwind-merge'

const lootboxImage = new URL('../assets/lootbox.png', import.meta.url).href
const lootboxSlasherImage = new URL('../assets/lootbox_slasher.png', import.meta.url).href

interface LootboxImageProps {
    lootbox: LootboxType
}

export const LootboxImage = ({ lootbox }: LootboxImageProps) => {
    const src = lootbox.colleciton === 'CQsVrYkv52tLB7howZAhbUZGBku5ysRH1Xmv5mq6LkPZ' ? lootboxSlasherImage : lootboxImage
    const [imgLoaded, setImgLoaded] = useState(false)
    const onload = () => setImgLoaded(true)
    return (
        <img
            loading='lazy'
            src={src}
            onLoad={onload}
            className={twMerge(
                'h-60 opacity-0 border border-white/10',
                !imgLoaded && 'bg-white/5 animate-pulse',
                imgLoaded && 'opacity-100 transition-opacity duration-500'
            )}
        />
    )
}
